import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M2 4h16v11.636H2z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M18 5.455c0-.051-3.582 3.151-8 4.727-4.418-1.576-8-4.778-8-4.727"
    }, null, -1)
  ]))]))
}
export default { render: render }